import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { faUsers, faWarning, faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ReportService } from 'src/app/services/report.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';

@Component({
  selector: 'app-view-team-supporting',
  templateUrl: './view-team-supporting.component.html',
  styleUrls: ['./view-team-supporting.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewTeamSupportingComponent implements OnInit, AfterViewInit {

  @Output() loaded = new EventEmitter();
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;
  faUsers = faUsers;
  faExternalLink = faExternalLink;

  page = input("7");
  report = input.required<any>();
  forests: string[] = []

  otherLinks: any[] = []

  pageLoaded = false;

  forestContacts: any[] = [];

  users = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'name',
    'role',
    'skills'
  ];

  reg = APP_CONSTANTS.URL_REGEX;

  constructor(
    public dialog: MatDialog,
    private readonly titleService: Title,
    private readonly router: Router,
    public readonly reportService: ReportService,
    private readonly userService: UserService,
    public readonly toast: ConfirmationToastComponent,
  ) {

  }

  loadUsers() {
    this.users.data = this.report().users;
    this.userService.getUserList("", ["baer_roles.baer_role"]).subscribe(data => {
      data.users.forEach((user: any) => {
        // 4- Forest BAER Coordinator
        // 5-Forest BAR Coordinator
        user.isFOCO = user.baer_roles.filter((obj: any) => [4, 5].includes(obj.baer_role.value))?.map((x: any) => x.forest_name ?? user.forest_name) ?? [];
        if (!user.isFOCO) return
        user.isFOCO.forEach((forestRole: any) => {
          if (this.forests.includes(forestRole)) {
            this.forestContacts.push(user);
          }
        })
      })
      this.pageLoaded = true;
    })
  }

  ngOnInit(): void {
    this.forests = this.report().assessment.forest_name.split(",")
    this.loadUsers();
    this.initOtherLinks();
  }

  ngAfterViewInit(): void {
    this.loaded.emit(7);
  }

  initOtherLinks() {
    this.report().supporting_files?.filter(
      (file: any) => file.question == "Other Links"
    ).forEach((file: any) => {
      this.otherLinks.push(file)
    })
  }

  decodeURI(url: string): string {
    return decodeURI(url)
  }
}
